










































import { Vue, Component, Prop } from 'vue-property-decorator';

import ArrowNarrowRightSolid from '~/components/icons/ArrowNarrowRightSolid.vue';

@Component({
  components: { ArrowNarrowRightSolid },
})
export default class BasicMobileFullModal extends Vue {
  @Prop(String) title: '';

  mounted () {
    if (process.client) window.addEventListener('keydown', this.onInputKeydown, false);
  }

  beforeDestroy () {
    if (process.client) window.removeEventListener('keydown', this.onInputKeydown);
  }

  /* If user hits Escape key, it will close modal */
  onInputKeydown (event: KeyboardEvent) {
    switch (event.key) {
      case 'Escape':
        return this.$emit('modal-close');
    }
  }
}
